import { BasketStoreModel } from '@agent/core/basket/basket.model';
import { copy } from 'angular';

import { ChannelType } from '@contact/upgrade';

import { toChannelReducer } from '../basket.store';
import { ActionsUnion, ActionTypes } from './visio-basket.action';
import { INITIAL_STATE_QUERY_FILTER, QueryFilterModel, VisioChannelModel } from './visio-basket.model';

/**
 * Main reducer to manage
 */
export function visioReducer(state: BasketStoreModel, action: ActionsUnion): BasketStoreModel {
  // convert visio channel reducer
  return toChannelReducer(ChannelType.VISIO, visioChannelReducer)(state, action);
}

/**
 * Sub reducer to manage request filters
 */
export function visioChannelReducer(state: VisioChannelModel, action: ActionsUnion): VisioChannelModel {
  switch (action.type) {
    case ActionTypes.CHANGE_QUERY_FILTER:
    case ActionTypes.RESET_QUERY_FILTER: {
      return {
        ...state,
        channel: ChannelType.VISIO,
        queryFilters: queryFiltersReducer(state.queryFilters, action),
      };
    }
    default:
      return state;
  }
}

/**
 * Sub reducer to manage query filters
 */
export function queryFiltersReducer(state: QueryFilterModel, action: ActionsUnion): QueryFilterModel {
  switch (action.type) {
    case ActionTypes.CHANGE_QUERY_FILTER: {
      const { filters } = action;
      return {
        ...state,
        ...filters,
        hasFilters: true,
      };
    }
    case ActionTypes.RESET_QUERY_FILTER:
      return copy(INITIAL_STATE_QUERY_FILTER);
    default:
      return state;
  }
}
